<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            My Account
          </h1>
          <h4
            id="myacct_current_spiral"
            class="text-white text-center"
            v-text="currentFoodSpiral"
          />
        </div>
      </div>
    </div>
    <account-navigation v-if="authenticated" />
    <router-view />
    <account-navigation v-if="authenticated" />
  </main>
</template>

<script>
import {mapGetters} from 'vuex';
import AccountNavigation from "../components/AccountNavigation";

export default {
  components: {
    AccountNavigation,
  },
  data() {
    return {
      usertype:'',
      usersub:'',
      userspirals:'',
    };
  },
  computed: {
    ...mapGetters('user', [
      'user',
      'authenticated'
    ]),
    currentFoodSpiral() {
      if (!this.$store.state.user.user) {
        if (this.userspirals.length) {
          // might be a race condition before this gets populated
          return 'Your current FOOD SPIRAL®: ' + this.userspirals;
        }
        return '';
      }
      if (!this.$store.state.user.user['food-spiral'].length) {
        return '';
      }
      return 'Your current FOOD SPIRAL®: ' + this.$store.state.user.user['food-spiral'][0].name;
    },
  },
  mounted(){
    this.check_user();
  },
  methods: {
    async check_user(){
      if (! this.authenticated && this.$route.meta?.allow_guest) {
        return;
      }

      if (this.$store.state.user.user) { console.log('skip account check_user'); return; } // skip if user state
      let checkuser = await this.$http('/api/share-portal/usertype',{
        method:"get",
      }).then(response => response.json())
        .then(async function(json) {
          if(json.message == "Unauthenticated."){
            throw new Error(JSON.stringify(json));
          }else{
            return json;
          }
        });

      console.log("checkuser", checkuser);
      try {
        this.userspirals = checkuser.spiral.userSpirals[0];
        // console.log('spirals:' + this.userspirals);
        switch(this.userspirals) {
        case 'ccfs':
          this.userspirals = 'Carb Counting';
          break;
        case 'lsfs':
          this.userspirals = 'Low Sodium';
          break;
        case 'dfs':
          this.userspirals = 'Diabetes';
          break;
        case 'rfs':
          this.userspirals = 'Renal';
          break;
        case 'rdfs':
          this.userspirals = 'Renal Diabetes';
          break;
        case 'hfs':
          this.userspirals = 'Healthy';
          break;
        }
        console.log('spirals: ' + this.userspirals);
        // if ( document.querySelector('#myacct_current_spiral').innerText == '' ) {
        //     document.querySelector('#myacct_currentz_spiral').innerText = 'Your current FOOD SPIRAL®: ' + this.userspirals;
        // }
      } catch (error) {
        //     this.userspirals = '';
        console.log('spirals: na');
      }

      if(checkuser.type=="Guest"){
        this.usertype = "Guest";
      }
      if(checkuser.type=="User"){
        this.usertype = "User";
      }
    },
    /**
         * If the current path is the submenu of menuItem, returns class 'active'
         *
         * @param {string}    menuItem
         * @return {string}
         */
    detectActiveSubMenu(menuItem) {
      return '';  // todo: remove detectActiveSubMenu()
      let subMenuItems = [];
      switch (menuItem) {
      case 'Food Database':
        subMenuItems = [
          '/account/food-search',
          '/account/food-groups',
          '/account/my-favorites',
          '/account/recipe-maker',
          '/account/fff-recipes',
        ];
        break;
      case 'Food Tracker':
        subMenuItems = [
          '/account/meal-entries',
          '/account/food-insights',
          '/account/progress-reports',
        ];
        break;
      }
      const className = (subMenuItems.indexOf(this.$route.path) >= 0) ? 'active' : '';
      // console.log('className', className, this.$route.path);  // For debug only
      return className;
    },
  }
};

</script>
